import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

export function ViewEvent({ eventDefID }) {
  return (
    <Button
      color="primary"
      href={`/events/schema/${eventDefID}`}
      target="_blank"
    >
      View Event Definition
    </Button>
  );
}

ViewEvent.propTypes = {
  eventDefID: PropTypes.string.isRequired,
};

export function DefineEvent({ type, typeSpecificProperty, targetText, path }) {
  const params = {
    type,
    typeSpecificProperty,
  };

  // If the event has any target text, we use the target text to filter the
  // event instead of the CSS selector.
  if (!!targetText) {
    params.targetText = targetText;
  }

  // Some events may include a path; if so, we'll want to pass that
  // along to the event def creator.
  if (!!path) {
    params.path = path;
  }

  return (
    <Button
      color="primary"
      href={`/events/schema/new?${new URLSearchParams(params).toString()}`}
    >
      Create Event
    </Button>
  );
}

DefineEvent.propTypes = {
  type: PropTypes.string.isRequired,
  typeSpecificProperty: PropTypes.string.isRequired,
};
